import React from 'react';
import classNames from 'classnames';
import GoogleMapReact from 'google-map-react';
import { GOOGLE_MAPS_API_KEY } from '../../config';
import SpinnerDots from '../spinner/dots';
import ScbStats from './scb-stats';

const MapContent = ({
    isLoadingMarkers,
    mapIsLoading,
    onGoogleApiLoaded,
    selectedAreas,
    demographicsOpen
}) => {
    const center = {
        lat: 59.3273056,
        lng: 17.8390038
    };

    return (
        <div className={classNames({
            'create-district-map__map': true,
            'create-district-map__map--is-loading': mapIsLoading,
            'create-district-map--is-loading-markers': isLoadingMarkers
        })} style={{ width: "100%", minHeight: '300px' }}>
            <GoogleMapReact
                bootstrapURLKeys={{
                    key: GOOGLE_MAPS_API_KEY,
                    language: 'sv'
                }}
                options={{
                    fullscreenControl: false
                }}
                defaultZoom={6}
                defaultCenter={center}
                yesIWantToUseGoogleMapApiInternals={true}
                onGoogleApiLoaded={({ map, maps }) => onGoogleApiLoaded(map, maps)}
            />

            <ScbStats 
                layerSelection={selectedAreas} 
                isOpen={demographicsOpen} 
            />

            <SpinnerDots />
        </div>
    );
};

export default MapContent; 